/* eslint-disable  @typescript-eslint/no-explicit-any */
import { clone } from '../utils/clone'
import { messages, validationError } from './errors'

interface Validation {
  predicateFn: () => boolean
  messageFn: () => string
}
class BaseValidator {
  public _validations: Validation[]
  public operatorName?: string

  constructor() {
    this._validations = []
  }

  arityIsZero(args: IArguments) {
    return this.addValidation(
      () => args.length === 0,
      () => messages.arityValidations.arityIsZero(this.operatorName ?? '')
    )
  }

  arityIsOne(args: IArguments) {
    return this.addValidation(
      () => args.length === 1,
      () => messages.arityValidations.arityIsOne(this.operatorName ?? '')
    )
  }

  arityIsTwo(args: IArguments) {
    return this.addValidation(
      () => args.length === 2,
      () => messages.arityValidations.arityIsTwo(this.operatorName ?? '')
    )
  }

  arityIsThree(args: IArguments) {
    return this.addValidation(
      () => args.length === 3,
      () => messages.arityValidations.arityIsThree(this.operatorName ?? '')
    )
  }

  arityIsAtLeastTwo(args: IArguments) {
    return this.addValidation(
      () => args.length >= 2,
      () => messages.arityValidations.arityIsAtLeastTwo(this.operatorName ?? '')
    )
  }

  arityIsAtLeastOne(args: IArguments | any[]) {
    return this.addValidation(
      () => args.length >= 1,
      () => messages.arityValidations.arityIsAtLeastOne(this.operatorName ?? '')
    )
  }

  addValidation(
    predicateFn: Validation['predicateFn'],
    messageFn: Validation['messageFn']
  ) {
    this._validations.push({
      predicateFn,
      messageFn,
    })
    return this
  }
}

export class AggregatingValidator extends BaseValidator {
  private _invalidArguments: string[]

  constructor(previousInvalidArguments?: string[]) {
    super()
    this._invalidArguments = clone(previousInvalidArguments)
  }

  validateAndAggregate(): [string[], boolean] {
    const valid = this._validations.every(({ predicateFn, messageFn }) =>
      this._appendIfInvalid(predicateFn(), messageFn())
    )
    return [this._invalidArguments, valid]
  }

  _appendIfInvalid(valid: boolean, message: string) {
    if (!valid) {
      this._invalidArguments.push(message)
      return false
    }
    return true
  }
}

export class RejectingValidator extends BaseValidator {
  validateAndReject(): Promise<void> {
    return Promise.resolve().then(() => {
      this._validations.forEach(({ predicateFn, messageFn }) => {
        if (!predicateFn()) {
          throw validationError(messageFn())
        }
      })
    })
  }

  validateAndReturn(): string[] {
    const errors: string[] = []
    this._validations.forEach(({ predicateFn, messageFn }) => {
      if (!predicateFn()) {
        errors.push(messageFn())
      }
    })
    return errors
  }
}
